import Vue from 'vue'
import App from './App.vue'
import store from './store'

// API Tool
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

// Fontawesome Icons
import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  faPrint,
  faPhone,
  faMapMarkerAlt,
  faHome,
  faClone,
  faChevronUp,
  faSave,
  faInfo,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons'
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
// Hinzufügen benätigter Icons
library.add(faPrint, faPhone, faMapMarkerAlt, faHome, faClone, faChevronUp, faSave, faInfo, faInfoCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

const prod = process.env.NODE_ENV === "production"
const shouldSW = 'serviceWorker' in navigator && prod

//console.log(navigator)
if (shouldSW) {
  navigator.serviceWorker.register('service-worker.js').then(() => {
    //console.log("Service Worker Registered!")
  })
}

new Vue({
  el: '#app',
  store,
  components: {
    App
  },
  template: '<App/>',
  render: h => h(App)
}).$mount('#app')